class CopyCode extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (e) => {
      e.preventDefault();

      navigator.clipboard.writeText(this.dataset.code);
    });

    this.setHoverEffect();
  }

  setHoverEffect() {
    const button = this.querySelector('.codes-multicolumn__copy-codes-btn');
    const hoverItem = this.querySelector('.copy-codes__hover');
    let listenerItem = null;

    button ? listenerItem = button : listenerItem = this;

    if (listenerItem) {
      listenerItem.addEventListener('click', (e) => {
        e.preventDefault();

        listenerItem.style.pointerEvents = 'none';
        hoverItem.classList.remove('hidden');

        gsap.set(hoverItem, { opacity: 1 });
        gsap.to(hoverItem, {
          delay: 1,
          opacity: 0,
          duration: 1.5,
          onComplete: function() {
            hoverItem.classList.add('hidden');
            listenerItem.style.pointerEvents = 'initial';
          }
        });
      });
    }
  }
}

customElements.define('copy-codes', CopyCode);
